module.exports = "/static/assets/b494a3e0b00941252c2e1cdde6b17e42.png";